// App.js
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./Views/login";
import RegisterProject from "./Views/registerProject";
import ViewProject from "./Views/viewProject";
import AllProjects from "./Views/allProjects";
import NotFound from "./Views/404";
import ProtectedRoute from "./Components/protectedRoute";
import AdminDashboard from "./Views/adminDashboard";
import { useAuth } from "./Context/authContext";
import LoadingScreen from "./Components/loadingScreen";
import ScrollToTop from "./Components/scrollToTop";
import GlobalErrorUI from "./Components/globalError";
import AccountingDashboard from "./Views/accountingDashboard";

const App = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route
          path="/"
          element={user ? <AllProjects /> : <Login loggedOut={false} />}
        />
        <Route path="/login" element={<Login loggedOut={true} />} />
        <Route
          path="/project/new"
          element={
            <ProtectedRoute>
              <RegisterProject />
            </ProtectedRoute>
          }
        />
        <Route
          path="/project/edit/:uid"
          element={
            <ProtectedRoute>
              <RegisterProject />
            </ProtectedRoute>
          }
        />
        <Route
          path="/project/:uid"
          element={
            <ProtectedRoute>
              <ViewProject />
            </ProtectedRoute>
          }
        />
        {
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
        }
        {
          <Route
            path="/accounting"
            element={
              <ProtectedRoute>
                <AccountingDashboard />
              </ProtectedRoute>
            }
          />
        }
        <Route path="*" element={<NotFound />} />
      </Routes>

      <GlobalErrorUI></GlobalErrorUI>
    </BrowserRouter>
  );
};

export default App;
